// frontend/src/features/ui/filtersSlice.js
// This Redux slice manages shared UPS UI filters:
// - agency selection
// - search query
// - scope
// - workforce source (all / agency / internal)
// It also exposes a UI-only stats refresh key used to force shared stats refreshes.

import { createSlice } from '@reduxjs/toolkit';

const initialFilters = {
  agencyId: '',     // '' = All Agencies
  q: '',
  scope: 'tab',
  source: 'all',    // 'all' | 'agency' | 'internal'
};

const initialState = {
  filters: initialFilters,
  statsRefreshKey: 0,
};

const filtersSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setAgencyId: (state, action) => {
      state.filters.agencyId = action.payload ?? '';
    },

    setQuery: (state, action) => {
      state.filters.q = action.payload ?? '';
    },

    setScope: (state, action) => {
      state.filters.scope = action.payload === 'global' ? 'global' : 'tab';
    },

    setSource: (state, action) => {
      const value = String(action.payload ?? 'all').toLowerCase();
      state.filters.source =
        value === 'agency' || value === 'internal' ? value : 'all';
    },

    reset: (state) => {
      state.filters = { ...initialFilters };
      state.statsRefreshKey = 0;
    },

    bumpStatsRefreshKey: (state) => {
      state.statsRefreshKey += 1;
    },
  },
});

export const {
  setAgencyId,
  setQuery,
  setScope,
  setSource,
  reset,
  bumpStatsRefreshKey,
} = filtersSlice.actions;

// Selectors
export const selectFilters = (s) => s.ui?.filters ?? initialFilters;
export const selectAgencyId = (s) => s.ui?.filters?.agencyId ?? '';
export const selectQuery = (s) => s.ui?.filters?.q ?? '';
export const selectScope = (s) => s.ui?.filters?.scope ?? 'tab';
export const selectSource = (s) => s.ui?.filters?.source ?? 'all';
export const selectStatsRefreshKey = (s) => s.ui?.statsRefreshKey ?? 0;

export default filtersSlice.reducer;